function getCurrentTier(tiers, points) {
  const eligibleTiers = tiers.filter((tier) => tier.from <= points);
  const currentTierIndex = eligibleTiers.length - 1;
  return eligibleTiers[currentTierIndex];
}

export default getCurrentTier;
